import TimelineWebAPI from '@api/timeline_web_api.js'

import Types from '../types.js'
import { handleLoadTimelinesSuccess, handleLoadTimelinesError } from './server_actions.js'

export const setupGroup = groupId => ({
  type: Types.SETUP_GROUP,
  payload: groupId,
})

export const loadGroupTimelines = (pageNumber, groupId) => {
  return (dispatch, getState) => {
    dispatch(groupTimelinesRequest(pageNumber, groupId))
    TimelineWebAPI.fetchGroupTimelines(groupId, pageNumber).then(
      res => {
        dispatch(handleLoadTimelinesSuccess(res, pageNumber, groupId))
      },
      err => {
        dispatch(handleLoadTimelinesError(err, pageNumber, groupId))
      }
    )
  }
}

export const paginateTo = (pageNumber, groupId) => ({
  type: Types.TIMELINES_PAGINATE,
  payload: {
    pageNumber,
    groupId,
  },
})

const groupTimelinesRequest = (pageNumber, groupId) => ({
  type: Types.TIMELINES_REQUEST,
  payload: {
    pageNumber,
    groupId,
  },
})

export default {
  setupGroup,
  loadGroupTimelines,
  paginateTo,
}
